<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm10_part01"><a id="page_7"></a><strong>P<span class="smallcaps">ART</span> I<br/>Which Germs Where?</strong><a id="page_8"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm10_part01.vue?463320ae